export default __webpack_public_path__ + "static/media/detail_mobile_9_2.d7f8e87b.jpg";